import type { CompanyTag } from "@shaarp/common";

/**
 * Compact card shown when hovering a company chip: what the assistant wrote on
 * the tag, nothing fetched. The full tag is in the side panel on click.
 */
export default function CompanyTagHoverCard({ tag }: { tag: CompanyTag }) {
  const meta = [tag.city, tag.activity].filter(Boolean).join(" · ");
  return (
    <div className="flex flex-col gap-1">
      <p className="truncate text-sm font-semibold">{tag.name}</p>
      {meta && <p className="text-xs text-muted-foreground">{meta}</p>}
      {tag.brief && (
        <p className="line-clamp-3 text-sm text-foreground/80">{tag.brief}</p>
      )}
    </div>
  );
}
